import type { JobLiveEntity } from './JobLiveEntity'

export class JobLiveResponseEntity {
  jobs?: Array<JobLiveEntity>
  showCanceledDeliveryDurationInSecond?: number
  showCompletedDeliveryDurationInSecond?: number
}
